export function validateProvincePayload(payload) {
  if (!payload?.departmentId) {
    return "El departamento es obligatorio.";
  }

  if (!payload?.name?.trim()) {
    return "El nombre es obligatorio.";
  }

  if (!payload?.code?.trim()) {
    return "El codigo es obligatorio.";
  }

  if (payload.code.trim().length > 5) {
    return "El codigo no debe exceder 5 caracteres.";
  }

  if (typeof payload?.calculatePrice !== "boolean") {
    return "El valor de calcular precio es obligatorio.";
  }

  if (typeof payload?.reservation !== "boolean") {
    return "El valor de reserva es obligatorio.";
  }

  return null;
}
